import { watch } from 'vue'

import { useRoute } from 'nuxt/app'

import { useAuth } from '@common/auth-layer/composables/useAuth'
import { useCPNavigation } from '@common/navigation-layer/composables/useNavigationContext'
import { useCPRouteContext } from './useCPRouteContext'

/**
 * Watches auth state in clientportal. When user logs out (isLoggedIn true → false):
 * - On communities-layer pages: intentionally does nothing here (avoid hard refresh / login bounce).
 * - On all other non-auth pages: redirects to auth-login with the current route as `redirect`
 *   query so the user can return after re-authenticating
 *   (aligned with auth.global middleware intent).
 * No-ops when already on an auth page to avoid redirect loops.
 */
export function useClientPortalAuthStateWatcher() {
  const authStore = useAuth().store
  const { CPNavigateTo } = useCPNavigation()
  const { isAuthPage, isCommunityLayerPage } = useCPRouteContext()
  const route = useRoute()

  watch(
    () => authStore.isLoggedIn,
    (isLoggedIn, wasLoggedIn) => {
      const isLoggedOut = wasLoggedIn === true && isLoggedIn === false
      const isNotAuthPage = !isAuthPage.value
      const isNotCommunityLayerPage = !isCommunityLayerPage.value

      if (isLoggedOut && isNotAuthPage && isNotCommunityLayerPage) {
        const redirectPath = route.fullPath
        const loginPath = '/login'
        if (redirectPath !== loginPath && !redirectPath.startsWith(loginPath)) {
          CPNavigateTo({
            name: 'auth-login',
            query: { redirect: redirectPath },
            options: { replace: true },
          })
        } else {
          CPNavigateTo({ name: 'auth-login', options: { replace: true } })
        }
      }
    },
    { immediate: false }
  )
}
